import '../App.css';
import { useState, useEffect } from 'react';
import axios from '../apis/Axios';
import { SERVER_URL } from '../apis/Api';
import CrossfadeSlider from './CrossfadeSlider';

function PhotoGallery(props) {
    const { isSlider, onAllImagesLoaded, onError } = props;
    const [images, setImages] = useState([]);

    useEffect(() => {
        const getImageData = async () => {          
            try { 
                const res = await axios.get('api/general/images/photography');
                const imageData = res.data;

                setImages(imageData);

                if (imageData.length === 0) {
                    onAllImagesLoaded?.();
                    return;
                }

                const batchSize = 5;
                const criticalBatch = imageData.slice(0, batchSize);

                const preloadBatch = criticalBatch.map(img => {
                    return new Promise((resolve) => {
                        const image = new Image();
                        image.src = SERVER_URL + img.url;
                        image.onload = resolve;
                        image.onerror = resolve;
                    });
                });

                await Promise.all(preloadBatch);

                onAllImagesLoaded?.();

            } catch (err) {
                onError?.(err);
            }
        };
        
        getImageData();
    }, [onAllImagesLoaded, onError]);

    const pattern = ['tall', 'normal'];

    return (
        <div>
            {
                isSlider ?
                    <CrossfadeSlider images={ images } />
                : 
                    <div style={{ maxWidth: '100%', margin: '4vw auto', padding: '0 10px' }}>
                        <div className='photo-gallery'>
                            <div className='photo-gallery-grid'>
                                {   
                                    images.map((img, index) => {
                                        const variant = pattern[index % pattern.length];
                                        const className = variant === 'normal'
                                            ? 'photo-gallery-item'
                                            : `photo-gallery-item photo-gallery-item-${variant}`;
                                        
                                        return (
                                            <div key={img.name} className={className}>
                                                <img
                                                    src={`${SERVER_URL + img.url}`}
                                                    loading={ index < 5 ? "eager" : "lazy" }
                                                    alt=''
                                                    style={{ 
                                                        width: '100%',
                                                        display: 'block',
                                                        backgroundColor: '#f0f0f0'
                                                    }}
                                                    onError={(e) => console.log('Failed to load the image: ', e.target.src)}
                                                />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default PhotoGallery;